<template>
  <div>
    <ActionBar dismissible @dismiss="handleDismiss">
      <!-- <ActionBarButton
        v-if="detail.status === 'dis'"
        slot="action"
        type="primary"
        @click="handleCancelDisposeButtonClick"
        >ยกเลิกตัดขายฝาก</ActionBarButton
      > -->

      <template #action>
        <el-button v-if="isAdmin && !isDeleted"  type="danger" @click="handleDeleteButtonClick">
          ลบรายการนี้</el-button>
        <el-button v-if="isDeleted" type="danger" plain disabled>
          ถูกลบแล้ว
        </el-button>
        <el-button  type="primary" @click="handlePrintButtonClick">พิมพ์ใบรับขายฝาก
        </el-button>
        <el-button v-if="!['rdm', 'dis'].includes(detail.status)" type="primary"
          @click="handleRedemptionButtonClick">ไถ่ถอน</el-button>
        <el-button v-if="!['rdm', 'dis'].includes(detail.status)" type="primary"
          @click="handleDisposeButtonClick">ตัดขายฝาก</el-button>
      </template>

      <ActionBarTitle>ขายฝาก / {{ detail.displayId }}
        <PawnTag tag="span" :type="detail.status" :style="{ padding: '0.25rem 0.5rem' }" />
      </ActionBarTitle>
    </ActionBar>
    <PageContainer>
      <AppContainer>
        <BasicDetail :customer="detail.customer" :code="detail.ticketNo" :start-date="detail.date" :end-date="endDate"
          :weight="detail.weight" :amount="detail.amount" :interest-per-month="detail.interestPerMonth" />
        <ReceivedInterest :value="detail.receivedInterest" :style="{ marginTop: '1.5rem' }" />
        <List :extendable="!['rdm', 'dis'].includes(detail.status)" :style="{ marginTop: '1.5rem' }"
          @extend="handleExtend">
          <template v-for="(item, index) in activities">
            <ListItem v-if="item.type === 'create'" :key="index" title="รับขายฝาก">
              <DataTable :items="item.data.items" readonly :style="{ marginBottom: '1rem' }" />

              <el-form label-position="top">
                <el-form-item label="หมายเหตุ">
                  <el-input type="textarea" :value="item.data.note" readonly :autosize="{ minRows: 3 }"></el-input>
                </el-form-item>
              </el-form>

              <img v-for="(evidence, evidenceIndex) in item.data.evidences" :key="evidenceIndex" :src="evidence"
                alt="Evidence" :style="{
                  display: 'block',
                  maxWidth: '100%',
                  margin: '0 auto 0.5rem'
                }" />

              <div :style="{ maxWidth: '40rem', margin: '1rem auto 0' }">
                <PanelBorderless>
                  <h2 slot="header" :style="{ fontSize: '1rem', margin: '0' }">
                    ช่องทางที่รับชำระ
                  </h2>

                  <PaymentDetail>
                    <PaymentDetailMethod :style="{ margin: '1em 0' }">
                      <PaymentDetailMethodItem v-for="(obj, idx) in item.data.paymentMethods" :key="idx"
                        :index="idx + 1" :name="obj.name" :bank="obj.bank" :account-no="obj.accountNo"
                        :amount="obj.amount" :fee-percentage="obj.feePercentage" :ref-no="obj.ref"
                        :show-detail="false" />
                    </PaymentDetailMethod>
                    <hr />
                    <PaymentDetailItem label="รวมที่ต้องชำระทั้งสิ้น" :value="item.data.getPaymentTotal()"
                      :style="{ fontWeight: 'bold' }" />
                    <hr />
                    <hr />
                  </PaymentDetail>
                </PanelBorderless>

                <PanelBorderless v-if="item.data.paymentEvidences.length">
                  <h2 slot="header" :style="{ fontSize: '1rem', margin: '0' }">
                    หลักฐาน/สลิป
                  </h2>

                  <FilePreviewList>
                    <FilePreviewListItem v-for="(obj, idx) in item.data.paymentEvidences" :key="idx">
                      <FilePreview :src="obj" :style="{ width: '150px', height: '150px' }" :removable="false" />
                    </FilePreviewListItem>
                  </FilePreviewList>
                </PanelBorderless>
              </div>
            </ListItem>
            <ListItem v-else-if="item.type === 'extend'" :key="index" title="ต่อขายฝาก ชำระดอก" :date="item.data.date"
              :due-date="item.data.dueDate">
              <div>{{ item.data.id }}</div>
              <ListCollapse>
                <ListInfo slot="header" type="extend" :amount="item.data.amountWithDiscount" :user="item.data.user">
                  <ListInfoDetail label="ดอกเบี้ย:" :value="item.data.amount" unit="บาท" />
                  <ListInfoDetail label="ส่วนลด:" :value="item.data.discount" unit="บาท" />
                </ListInfo>
                <el-button slot="actions" size="mini" @click="handleActivityPrintButtonClick('extend', item.id)">
                  พิมพ์ใบต่อขายฝาก ชำระดอก
                </el-button>

                <div :style="{ maxWidth: '40rem', margin: '0 auto' }">
                  <PanelBorderless>
                    <h2 slot="header" :style="{ fontSize: '1rem', margin: '0' }">
                      ช่องทางที่รับชำระ
                    </h2>

                    <PaymentDetail>
                      <PaymentDetailMethod :style="{ margin: '1em 0' }">
                        <PaymentDetailMethodItem v-for="(obj, idx) in item.data.paymentMethods" :key="idx"
                          :index="idx + 1" :name="obj.name" :bank="obj.bank" :account-no="obj.accountNo"
                          :amount="obj.amount" :fee-percentage="obj.feePercentage" :ref-no="obj.ref"
                          :show-detail="!obj.isCash" />
                      </PaymentDetailMethod>
                      <hr />
                      <PaymentDetailItem label="รวมเงินที่รับชำระ" :value="item.data.receivedAmount" />
                      <hr />
                      <PaymentDetailItem label="จำนวนเงินหลักหักส่วนลด" :value="item.data.amountWithDiscount" />
                      <PaymentDetailItem label="รวมค่าธรรมเนียม" :value="item.data.fee" />
                      <hr />
                      <PaymentDetailItem label="รวมที่ต้องชำระทั้งสิ้น" :value="item.data.totalPaid"
                        :style="{ fontWeight: 'bold' }" />
                      <hr />
                      <hr />
                      <PaymentDetailItem label="เงินทอน" :value="item.data.change" />
                    </PaymentDetail>
                  </PanelBorderless>

                  <PanelBorderless v-if="item.data.paymentEvidences.length">
                    <h2 slot="header" :style="{ fontSize: '1rem', margin: '0' }">
                      หลักฐาน/สลิป
                    </h2>

                    <FilePreviewList>
                      <FilePreviewListItem v-for="(obj, idx) in item.data.paymentEvidences" :key="idx">
                        <FilePreview :src="obj" :style="{ width: '150px', height: '150px' }" :removable="false" />
                      </FilePreviewListItem>
                    </FilePreviewList>
                  </PanelBorderless>
                </div>
              </ListCollapse>
            </ListItem>
            <ListItem v-else-if="item.type === 'redeem'" :key="index" title="ไถ่ถอนทอง" :date="item.data.date">
              <ListCollapse>
                <ListInfo slot="header" type="redeem" :amount="item.data.amountWithDiscount" :user="item.data.user">
                  <ListInfoDetail label="เงินขายฝาก:" :value="item.data.principalAmount" unit="บาท" />
                  <ListInfoDetail label="ดอกเบี้ย:" :value="item.data.amount" unit="บาท" />
                  <ListInfoDetail label="ส่วนลด:" :value="item.data.discount" unit="บาท" />
                </ListInfo>

                <el-button slot="actions" size="mini" @click="handleActivityPrintButtonClick('redeem', item.id)">
                  พิมพ์ใบไถ่ถอน
                </el-button>

                <div :style="{ maxWidth: '40rem', margin: '0 auto' }">
                  <PanelBorderless>
                    <h2 slot="header" :style="{ fontSize: '1rem', margin: '0' }">
                      ช่องทางที่รับชำระ
                    </h2>

                    <PaymentDetail>
                      <PaymentDetailMethod :style="{ margin: '1em 0' }">
                        <PaymentDetailMethodItem v-for="(obj, idx) in item.data.paymentMethods" :key="idx"
                          :index="idx + 1" :name="obj.name" :bank="obj.bank" :account-no="obj.accountNo"
                          :amount="obj.amount" :fee-percentage="obj.feePercentage" :ref-no="obj.ref"
                          :show-detail="!obj.isCash" />
                      </PaymentDetailMethod>
                      <hr />
                      <PaymentDetailItem label="รวมเงินที่รับชำระ" :value="item.data.receivedAmount" />
                      <hr />
                      <PaymentDetailItem label="จำนวนเงินหลักหักส่วนลด" :value="item.data.amountWithDiscount" />
                      <PaymentDetailItem label="รวมค่าธรรมเนียม" :value="item.data.fee" />
                      <hr />
                      <PaymentDetailItem label="รวมที่ต้องชำระทั้งสิ้น" :value="item.data.totalPaid"
                        :style="{ fontWeight: 'bold' }" />
                      <hr />
                      <hr />
                      <PaymentDetailItem label="เงินทอน" :value="item.data.change" />
                    </PaymentDetail>
                  </PanelBorderless>

                  <PanelBorderless v-if="item.data.paymentEvidences.length">
                    <h2 slot="header" :style="{ fontSize: '1rem', margin: '0' }">
                      หลักฐาน/สลิป
                    </h2>

                    <FilePreviewList>
                      <FilePreviewListItem v-for="(obj, idx) in item.data.paymentEvidences" :key="idx">
                        <FilePreview :src="obj" :style="{ width: '150px', height: '150px' }" :removable="false" />
                      </FilePreviewListItem>
                    </FilePreviewList>
                  </PanelBorderless>
                </div>
              </ListCollapse>
            </ListItem>
            <ListItem v-else-if="item.type === 'dispose'" :key="index" title="ตัดขายฝาก" :date="item.data.date">
              <ListInfo type="dispose" :amount="null" :user="item.data.user" />
            </ListItem>
          </template>
          <ListFooter slot="footer" :user="detail.user" :due-date="detail.dueDate" />
        </List>
      </AppContainer>
    </PageContainer>
  </div>
</template>

<script>
// Libs
import Vue from 'vue'
import store from '@/store'
import { mapActions, mapGetters, mapState } from 'vuex'

// Components
import {
  ActionBar,
  //ActionBarButton,
  ActionBarTitle
} from '@/components/ui/action-bar'
import { AppContainer } from '@/components/ui/container'
import { PageContainer } from '@/components/page/page-container'
import { PanelBorderless } from '@/components/page/panel-borderless'
import {
  PaymentDetail,
  PaymentDetailItem,
  PaymentDetailMethod,
  PaymentDetailMethodItem
} from '@/components/page/payment-detail'
import {
  FilePreview,
  FilePreviewList,
  FilePreviewListItem
} from '@/components/page/file-preview'

import PawnTag from '../components/Tag'
import BasicDetail from './BasicDetail'
import ReceivedInterest from './ReceivedInterest'
import List from './List'
import ListItem from './ListItem'
import ListInfo from './ListInfo'
import ListInfoDetail from './ListInfoDetail'
import ListCollapse from './ListCollapse'
import ListFooter from './ListFooter'
import DataTable from '../components/DataTable'

const ExtensionDialog = () => import('./ExtensionDialog')
const RedemptionDialog = () => import('./RedemptionDialog')
const DisposalDialog = () => import('./DisposalDialog')

// Functions
import { back } from '@/utils/navigation'
import { useLoading } from '@/use/loading'
import { PawnHistoryService } from '@/services'

export default {
  components: {
    ActionBar,
    //ActionBarButton,
    ActionBarTitle,
    PageContainer,
    AppContainer,
    PawnTag,
    BasicDetail,
    ReceivedInterest,
    List,
    ListItem,
    ListInfo,
    ListInfoDetail,
    ListCollapse,
    ListFooter,
    DataTable,
    PanelBorderless,
    PaymentDetail,
    PaymentDetailItem,
    PaymentDetailMethod,
    PaymentDetailMethodItem,
    FilePreview,
    FilePreviewList,
    FilePreviewListItem
  },

  computed: {
    ...mapGetters('auth', ['isAdmin']),

    ...mapState('pawnDetail', ['detail', 'activities']),

    isDeleted() {
      return this.detail && !!this.detail.deleted
    },

    endDate() {
      if (['rdm', 'dis'].includes(this.detail.status)) {
        return this.activities[0] ? this.activities[0].data.date : new Date()
      }

      return new Date()
    },

    latestActionDate() {
      return this.activities[0] ? this.activities[0].data.date : new Date()
    }
  },

  async beforeRouteEnter(to, from, next) {
    const { id } = to.params

    const loading = useLoading()

    try {
      await store.dispatch('pawnDetail/fetchDetail', id)

      next()
    } catch (e) {
      next(e)
    } finally {
      loading.close()
    }
  },

  methods: {
    ...mapActions('pawnDetail', {
      async fetchDetail(dispatch) {
        const loading = useLoading()

        try {
          await dispatch('fetchDetail', this.$route.params.id)
        } catch (e) {
          this.$notify.error(e.message)
        } finally {
          loading.close()
        }
      }
    }),

    async handleRedemptionButtonClick() {
      const module = await RedemptionDialog()
      const Ctor = Vue.extend(module.default)
      const vm = new Ctor({
        propsData: {
          code: this.detail.ticketNo,
          date: this.detail.date,
          latestDate: this.latestActionDate,
          interestPerMonth: this.detail.interestPerMonth,
          amount: this.detail.amount
        }
      }).$mount()
      this.$el.appendChild(vm.$el)

      vm.$on('save', value => {
        this.$store.commit('pawnDetail/SET_REDEMPTION_FORM', value)

        this.$router.push({
          name: 'PawnDetailCheckout',
          params: { ...this.$route.params, type: 'redemption' }
        })
      })
    },

    async handleDisposeButtonClick() {
      const module = await DisposalDialog()
      const Ctor = Vue.extend(module.default)
      const vm = new Ctor({
        propsData: {
          code: this.detail.ticketNo,
          date: this.detail.date
        }
      }).$mount()
      this.$el.appendChild(vm.$el)

      vm.$on('save', async (value, setLoading, done) => {
        const data = {
          datetime: value.date,
          note: 'ตัดขายฝาก',
          attachments: []
        }

        try {
          await PawnHistoryService.dispose(this.$route.params.id, data)

          done()

          this.fetchDetail()

          this.$notify.success('ตัดขายฝากเรียบร้อยแล้ว')
        } catch (e) {
          this.$notify.error(e.message)
        } finally {
          setLoading(false)
        }
      })
    },

    handleCancelDisposeButtonClick() {
      console.log('cancel dispose')
    },

    handlePrintButtonClick() {
      const route = this.$router.resolve({
        name: 'PawnPrint',
        params: this.$route.params
      })

      window.open(route.href)
    },

    handleActivityPrintButtonClick(type, id) {
      const route = (() => {
        switch (type) {
          case 'extend':
            return this.$router.resolve({
              name: 'PawnExtendPrint',
              params: { ...this.$route.params, ...{ activityId: id } }
            })

          case 'redeem':
            return this.$router.resolve({
              name: 'PawnRedeemPrint',
              params: { ...this.$route.params, ...{ activityId: id } }
            })
        }
      })()

      window.open(route.href)
    },

    async handleDeleteButtonClick() {
      try {
        await this.$confirm(
          'ต้องการที่จะลบรายการหรือไม่',
          'ยืนยันการลบรายการ',
          {
            confirmButtonText: 'ลบ',
            cancelButtonText: 'ไม่',
            type: 'warning'
          }
        )

        const loading = useLoading()

        try {
          await PawnHistoryService.del(this.$route.params.id)

          this.$notify.success('ลบรายการเรียบร้อย')

          back({ name: 'Pawn' })
        } catch (e) {
          this.$notify.error(e.message)
        } finally {
          loading.close()
        }
      } catch (e) {
        //
      }
    },

    handleDismiss() {
      back({ name: 'Pawn' })
    },

    async handleExtend() {
      const module = await ExtensionDialog()
      const Ctor = Vue.extend(module.default)
      const vm = new Ctor({
        propsData: {
          code: this.detail.ticketNo,
          date: this.detail.date,
          latestDate: this.latestActionDate,
          interestPerMonth: this.detail.interestPerMonth
        }
      }).$mount()
      this.$el.appendChild(vm.$el)

      vm.$on('save', value => {
        this.$store.commit('pawnDetail/SET_EXTENSION_FORM', value)

        this.$router.push({
          name: 'PawnDetailCheckout',
          params: { ...this.$route.params, type: 'extension' }
        })
      })
    }
  }
}
</script>
